// 模板字符串渲染
export default function(template, data) {
  return template.replace(/\{\{(.*?)\}\}/g, (match, key) => data[key.trim()]);
}



// WEBPACK FOOTER //
// ./src/util/template-transform.js